import { required, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      code: {
        required: helpers.withMessage(i18n.global.t('Please enter a branch code.'), required)
      },
      name: {
        required: helpers.withMessage(i18n.global.t('Please enter a branch name.'), required)
      },
      is_main: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required)
      },
      is_active: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required)
      },
      telephone1: {
      },
      address: {},
      postal_code: {},
      sub_district: {},
      district: {},
      province: {}
    }
  }
};
